export default function IP68(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_2058_27474)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24 38C28.4183 38 32 34.3064 32 29.75C32 22.05 24 16 24 16C24 16 16 22.05 16 29.75C16 34.3064 19.5817 38 24 38Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11 21C13.7614 21 16 18.6495 16 15.75C16 10.85 11 7 11 7C11 7 6 10.85 6 15.75C6 18.6495 8.23857 21 11 21Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.5 14C33.433 14 35 12.3211 35 10.25C35 6.75 31.5 4 31.5 4C31.5 4 28 6.75 28 10.25C28 12.3211 29.567 14 31.5 14Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_2058_27474">
                    <rect width="44" height="44" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
